import React from 'react';
import { Button } from 'react-bootstrap';
import { FaCirclePlus } from 'react-icons/fa6';

export default function AddWidgetComponent({ openWidgetSelector }) {
  return (
    <Button
      variant="primary"
      className="d-flex align-items-center justify-content-center h-100 w-100 rounded-2 bg-base"
      onClick={openWidgetSelector}
    >
      <FaCirclePlus size={45} color="#fff" />
    </Button>
  );
}
